/**
 * Public barrel export for the MobileFilterOption component.
 * @module features/scouting/components/MobileFilterSheet/MobileFilterOption
 */
export { default } from "./MobileFilterOptionContainer";
